module.exports = __webpack_public_path__ + "img/04.a3243c80.png";